import servicesProvider from "./ServicesProvider";
import Fetch from "../script/Fetch";
import Menu from "orser-model/Menu";
import { Ristorante } from "orser-model/Ristorante";
import DeliverectChannelRegistrationBodyRequest from "../model/DeliverectChannelRegistrationBodyRequest";
import { RistoranteTilby } from "orser-model/RistoranteTilby";
import { Fattura } from "orser-model/Fattura";
import { Ricevuta } from "orser-model/Ricevuta";

export class RistoranteService {
    async getRistoranteById(ristoranteId: string) {
        return servicesProvider.getRistoranteDbQueries().selectById(ristoranteId);
    }

    async getActiveMenuByRistoranteId(ristoranteId: string) {
        try {
            const getLocalTimestamp = () => {
                const date = new Date();
                const tzOffset = date.getTimezoneOffset() * 60000;
                return new Date(date.getTime() - tzOffset).toISOString().slice(0, -1);
            };

            const localTimestamp = getLocalTimestamp();

            const response = await Fetch.doFetch(
                `/ristorante/${ristoranteId}/menu/active?timestamp=${encodeURIComponent(localTimestamp)}`,
                { method: "GET" }
            );

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Errore nel recupero del menu attivo');
            }

            return await response.json();
        } catch (error: any) {
            console.error('Errore nel recupero del menu attivo:', error);
            throw error;
        }
    }

    async getMenuListByRistoranteId(ristoranteId: string) {
        try {
            const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/menu`, {
                method: "GET"
            });
            let jsonObject = await response.json();
            if (Array.isArray(jsonObject)) {
                return jsonObject.map((jsonObject: any) => Menu.fromJson(jsonObject));
            }
        } catch (error: any) {
            throw new Error("Errore durante il recupero del menu attivo.");
        }
    }

    async getRistoranteFromDBById(id: string) {
        try {
            const response = await Fetch.doFetch(`/ristorante/${id}`, {
                method: "GET"
            });
            const data = await response.json();
            return Ristorante.fromJson(data);
        } catch (error: any) {
            console.error('Errore durante il recupero dei dati:', error.message);
        }
    }

    async openRistoranteById(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/ristorante/${ristoranteId}/open`, {
                method: "POST"
            });
        } catch (error: any) {
            throw new Error("Errore durante l'apertura del ristorante.");
        }
    }

    async closeRistoranteById(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/ristorante/${ristoranteId}/close`, {
                method: "POST"
            });
        } catch (error: any) {
            throw new Error("Errore durante la chiusura del ristorante.");
        }
    }

    async getDeliverectInfoByRistoranteId(ristoranteId: string) {
        try {
            const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/deliverect`, {
                method: "GET"
            });
            let result = await response.json();
            console.log(`/ristorante/${ristoranteId}/deliverect`);

            return DeliverectChannelRegistrationBodyRequest.fromJson(result);
        } catch (error: any) {
            throw new Error("Errore durante il recupero delle informazioni Deliverect.");
        }
    }

    async getTilbyInfoByRistoranteId(ristoranteId: string) {
        const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/tilby`, {
            method: "GET"
        });
        let result = await response.json();

        return RistoranteTilby.fromJson(result);
    }

    async downloadMenuFromTilbyById(ristoranteId: string) {
        return await Fetch.doFetch(`/tilby/${ristoranteId}/menu`, {
            method: "POST"
        });
    }

    async getFatturaListByRistoranteId(ristoranteId: string) {
        const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/fatture`, {
            method: "GET"
        });

        if (!response.ok) {
            throw new Error("Errore durante il recupero delle fatture.");
        }

        let result = await response.json();

        if (!Array.isArray(result)) {
            console.log(result);
            throw new Error("Errore durante il recupero delle fatture: dati non validi.");
        }

        return result.map((jsonObject: any) => Fattura.fromJSON(jsonObject));
    }

    async getRicevutaListByRistoranteId(ristoranteId: string) {
        const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/ricevute`, {
            method: "GET"
        });

        if (!response.ok) {
            throw new Error("Errore durante il recupero delle ricevute.");
        }

        let result = await response.json();

        if (!Array.isArray(result)) {
            console.log(result);
            throw new Error("Errore durante il recupero delle ricevute: dati non validi.");
        }

        return result.map((jsonObject: any) => Ricevuta.fromJSON(jsonObject));
    }
}